import cssRegister from '@coorpacademy/css-modules-require-hook';

cssRegister();
